module.exports = __webpack_public_path__ + "img/niao.a03ad441.jpg";